// [#310-DIAG] Module-level navigation breadcrumb store.
// Lets AppErrorBoundary attach the last navigation action + previous URL to
// any crash payload. Pure side-effect-free state — no React involvement.

let _lastAction = null;
let _lastLocation = null;
let _history = []; // last 5 actions for context

export function recordNavigation(action, location) {
  _lastAction = { action, location, at: new Date().toISOString() };
  _lastLocation = typeof window !== "undefined" ? window.location.href : null;
  _history.push(_lastAction);
  if (_history.length > 5) _history.shift();
}

export function getNavigationDiagnostics() {
  return {
    lastAction: _lastAction,
    previousUrl: _lastLocation,
    recentActions: [..._history],
  };
}
